import React from 'react';

const TopBarTitle = ({ pageTitle,pageTitleWord }) => {
  return <div className=''> <span className='title1 ms-3'>{pageTitleWord}</span> <span className='topbar-title ms-0'>{pageTitle}</span></div>;
};

export default TopBarTitle;
